// Position GPS de l'appareil (tablette portail/kiosque) — best effort, mise en cache 5 min.
// Sert à confirmer que le scan des badges a bien lieu dans le périmètre de l'école.
let _cache = null;
let _cacheAt = 0;

export const getDevicePosition = () =>
  new Promise((resolve) => {
    if (_cache && Date.now() - _cacheAt < 5 * 60 * 1000) return resolve(_cache);
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        _cache = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        };
        _cacheAt = Date.now();
        resolve(_cache);
      },
      () => resolve(null), // refusé / indisponible → scan quand même, sans confirmation GPS
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 300000 }
    );
  });
